// @ vendors
const moment = require('moment');
const get = require('lodash/object/get');
const trim = require('lodash/string/trim');

// @ helpers
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet, APIPost } = require('utilities/APIRequestHelper');
const { downloadAsFile, base64ToBlob } = require('utilities/APIRequestHelper');
const IbanHelper = require('utilities/ibanHelper');

// @ actions
const signaturePatternActions = require('actions/signaturePattern');
const { updateConsents } = require('actions/gdprConsents');

// @ constants
const actionTypes = require('constants/actionTypes');
// @ actions
const BrokerMyInvestmentsActions = require('actions/brokerMyInvestments');
const errorActions = require('actions/brokerError');

const {
    FIRST_STEP,
    WIZARD_FIRST_STEP,
    DATE_FORMAT_API,
    BROKER_EMPLOYEE_ID,
    BROKER_CONTRIBUTION_PLAN_PERIODIC_ANUAL_REV_OPTION_NOREV_VALUE,
    BROKER_CONTRIBUTION_PLAN_PERIODIC_MONTHLY_OPTION_MONTH_VALUE,
    BROKER_CONTRIBUTION_PLAN_PERIODIC_MONTHLY_OPTION_TRIANUAL_VALUE,
    BROKER_CONTRIBUTION_PLAN_PERIODIC_MONTHLY_OPTION_BIANUAL_VALUE,
    BROKER_CONTRIBUTION_PLAN_PERIODIC_MONTHLY_OPTION_ANUAL_VALUE,
    BROKER_HIRE_PENSION_PLAN_CATEGORY,
    BROKER_HIRE_PENSION_PLAN_SUB_CATEGORY,
    CONTENT_TYPE_PDF,
    BROKER_HIRE_PLAN_FORMAT_MAIL
} = require('constants/index');

const reset = () => ({
    type: actionTypes.BROKER_HIRE_PENSION_PLAN_RESET
});

const setVisibleStep = step => ({
    type: actionTypes.BROKER_HIRE_PENSION_PLAN_SET_VISIBLE_STEP,
    payload: {
        step
    }
});

const setWillLeave = () => ({
    type: actionTypes.BROKER_HIRE_PENSION_PLAN_WILL_LEAVE
});

const setWillCancel = willCancel => ({
    type: actionTypes.BROKER_HIRE_PENSION_PLAN_WILL_CANCEL,
    payload: {
        willCancel
    }
});

const validationSuccess = response => ({
    type: actionTypes.BROKER_HIRE_PENSION_PLAN_VALIDATE_SUCCESS,
    payload: {
        data: get(response, 'contratoPlan')
    }
});

const apiValidationFailure = (response, history) => (dispatch) => {
    const errorKey = get(response, ['body', 'error'], '');

    dispatch({
        type: actionTypes.BROKER_HIRE_PENSION_PLAN_VALIDATE_FAILURE,
        payload: {
            data: get(response, 'error.description')
        }
    });

    dispatch(errorActions.show(`brokerAPIErrors-${errorKey}`, true, history));
};

const validationRequest = () => ({
    type: actionTypes.BROKER_HIRE_PENSION_PLAN_VALIDATE_REQUEST
});

const setContributionAnswer = value => ({
    type: actionTypes.BROKER_HIRE_PENSION_PLAN_CONTRIBUTION_ANSWER,
    payload: {
        value
    }
});

const setAccountNumber = accountId => ({
    type: actionTypes.BROKER_HIRE_PENSION_PLAN_SET_ACCOUNT_NUMBER,
    payload: {
        accountId
    }
});

const setAnnualIncrement = increment => ({
    type: actionTypes.BROKER_HIRE_PENSION_PLAN_SET_ANNUAL_INCREMENT,
    payload: {
        increment
    }
});

const setAnnualIncrementPercentage = percentage => ({
    type: actionTypes.BROKER_HIRE_PENSION_PLAN_SET_ANNUAL_INCREMENT_PERCENTAGE,
    payload: {
        percentage
    }
});

const setDate = date => ({
    type: actionTypes.BROKER_HIRE_PENSION_PLAN_SET_DATE,
    payload: {
        date
    }
});

const setInitialContribution = amount => ({
    type: actionTypes.BROKER_HIRE_PENSION_PLAN_SET_INITIAL_CONTRIBUTION,
    payload: {
        amount
    }
});

const setIntervener = intervener => ({
    type: actionTypes.BROKER_HIRE_PENSION_PLAN_SET_INTERVENER,
    payload: {
        intervener
    }
});

const setPeriodicityAmount = amount => ({
    type: actionTypes.BROKER_HIRE_PENSION_PLAN_SET_PERIODICITY_AMOUNT,
    payload: {
        amount
    }
});

const setPeriodicityWhitMinimum = (periodicity, minimum) => ({
    type: actionTypes.BROKER_HIRE_PENSION_PLAN_SET_PERIODICITY,
    payload: {
        periodicity,
        minimum
    }
})

const setPeriodicity = evt => (dispatch, getState) => {
    const immBrokerPensionPlans = getState().brokerPensionPlans;
    const periodicity = evt.value;
    let periodicityMinimum;
    switch (periodicity) {
        case BROKER_CONTRIBUTION_PLAN_PERIODIC_MONTHLY_OPTION_MONTH_VALUE: {
            periodicityMinimum = immBrokerPensionPlans.getIn(['pensionPlan', 'monthlyMinimum']);
        }
            break;
        case BROKER_CONTRIBUTION_PLAN_PERIODIC_MONTHLY_OPTION_TRIANUAL_VALUE: {
            periodicityMinimum = immBrokerPensionPlans.getIn(['pensionPlan', 'triannualMinimum']);
        }
            break;
        case BROKER_CONTRIBUTION_PLAN_PERIODIC_MONTHLY_OPTION_BIANUAL_VALUE: {
            periodicityMinimum = immBrokerPensionPlans.getIn(['pensionPlan', 'biannualMinimum']);
        }
            break;
        case BROKER_CONTRIBUTION_PLAN_PERIODIC_MONTHLY_OPTION_ANUAL_VALUE: {
            periodicityMinimum = immBrokerPensionPlans.getIn(['pensionPlan', 'annualMinimum']);
        }
            break;
        default: periodicityMinimum = immBrokerPensionPlans.getIn(['pensionPlan', 'monthlyMinimum']);
    }
    dispatch(setPeriodicityWhitMinimum(periodicity, periodicityMinimum))
};

const requestAccountsInProgress = () => ({
    type: actionTypes.BROKER_HIRE_PENSION_PLAN_FETCH_ACCOUNTS_REQUEST
});

const requestAccountsSuccess = (response, immAccounts) => ({
    type: actionTypes.BROKER_HIRE_PENSION_PLAN_FETCH_ACCOUNTS_SUCCESS,
    payload: {
        accounts: get(response, 'datos.dato'),
        immAccounts
    }
});

const requestAccountsFailure = error => ({
    type: actionTypes.BROKER_HIRE_PENSION_PLAN_FETCH_ACCOUNTS_FAILURE,
    payload: {
        error
    }
});

const requestIntervenersInProgress = () => ({
    type: actionTypes.BROKER_HIRE_PENSION_PLAN_FETCH_INTERVENERS_REQUEST
});

const requestIntervenersSuccess = response => ({
    type: actionTypes.BROKER_HIRE_PENSION_PLAN_FETCH_INTERVENERS_SUCCESS,
    payload: {
        interveners: get(response, 'datos.dato')
    }
});

const requestIntervenersFailure = error => ({
    type: actionTypes.BROKER_HIRE_PENSION_PLAN_FETCH_INTERVENERS_FAILURE,
    payload: {
        error
    }
});

const hirePensionPlanDownloadPDF = (response, downloadFileName) => {
    const base64String = `data:${CONTENT_TYPE_PDF};base64,${get(response, 'pdfBase64')}`;
    downloadAsFile(base64ToBlob(base64String), CONTENT_TYPE_PDF, downloadFileName);
};

const hirePensionPlanGetLink = (response) => {
    const base64String = `data:${CONTENT_TYPE_PDF};base64,${get(response, 'pdfBase64')}`;
    const data = [base64ToBlob(base64String)];
    const blobObject = new Blob(data, { type: CONTENT_TYPE_PDF });
    const blobURL = window.URL.createObjectURL(blobObject);
    if (!__CONTACT_CENTER__) {
        window.open(blobURL);
    }

    return {
        type: actionTypes.BROKER_HIRE_PENSION_PLAN_BUILD_LINK,
        payload: {
            link: blobURL
        }
    }
};

const requestAccounts = (history) => (dispatch, getState) => {
    const immAccounts = getState().accounts.get('byId');
    dispatch(requestAccountsInProgress());
    return APIGet(dispatch, apiURLBuilder.getURL('brokerHirePensionPlanAccounts'))
        .then(response => dispatch(requestAccountsSuccess(response, immAccounts)))
        .catch(response => {
            if (response.error) {
                dispatch(requestAccountsFailure(response.error.description));
            }
            const errorKey = get(response, ['body', 'error'], '');
            dispatch(errorActions.show('brokerAPIErrors-' + errorKey, true, history));
        });
};

const requestInterveners = (accountNumber, history) => (dispatch, getState) => {
    const immAccounts = getState().accounts.get('byId');
    const immAccount = immAccounts.get(accountNumber);
    const contractNumber = immAccount.get('contractNumber');
    const productNumber = immAccount.get('product');

    const requestData = {
        query: {
            producto: productNumber,
            numeroContrato: contractNumber
        }
    };

    dispatch(requestIntervenersInProgress());
    return APIGet(dispatch, apiURLBuilder.getURL('brokerHirePensionPlanInterveners'), requestData)
        .then(response => dispatch(requestIntervenersSuccess(response)))
        .catch(response => {
            if (response.error) {
                dispatch(requestIntervenersFailure(response.error.description));
            }
            const errorKey = get(response, ['body', 'error'], '');
            dispatch(errorActions.show('brokerAPIErrors-' + errorKey, true, history));
        });
};

const hirePensionPlanInProgress = () => ({
    type: actionTypes.BROKER_HIRE_PENSION_PLAN_REQUEST
})
const hirePensionPlanSuccess = response => ({
    type: actionTypes.BROKER_HIRE_PENSION_PLAN_SUCCESS,
    payload:
        response,
})
const hirePensionPlanFailure = error => ({
    type: actionTypes.BROKER_HIRE_PENSION_PLAN_FAILURE,
    payload:
        error,
})






const setPensionPlan = (dispatch, getState, signaturePatternToken, history) => {
    const { brokerPensionPlans, brokerHirePensionPlan, accounts, brokerPlanLegalDocument, brokerLegalDocumentation } = getState();
    const immHirePensionPlanStep1 = brokerHirePensionPlan.getIn(['steps', FIRST_STEP]);
    const immAccount = accounts.getIn(['byId', immHirePensionPlanStep1.get('accountId')]);
    const selectedIntervener = immHirePensionPlanStep1.get('selectedIntervener');
    const pensionPlanCurrency = brokerPensionPlans.getIn(['pensionPlan', 'customMinimumPurchaseAmount', 'currency']);
    const accountNumber = immAccount ? immAccount.get('iban') : '';
    const dgsCode = brokerPensionPlans.getIn(['pensionPlan', 'dgscode']);
    const fundamentalPlanDataUrl = brokerPlanLegalDocument.get('fundamentalPlanDataUrl');
    const specificationsDocumentUrl = brokerPlanLegalDocument.get('specificationsDocumentUrl');
    const contractProvisionServicesNaturalPersonsUrl = brokerPlanLegalDocument.get('contractProvisionServicesNaturalPersonsUrl');

    let periodicityDate = null;
    let periodictyAmount = 0;

    if (immHirePensionPlanStep1.get('periodicContribution')) {
        periodicityDate = immHirePensionPlanStep1.get('periodicityDate').format(DATE_FORMAT_API);
        periodictyAmount = immHirePensionPlanStep1.get('periodicityAmount');
    }

    const immIntervener = immHirePensionPlanStep1.getIn(['interveners', selectedIntervener.toString()]);
    const planName = brokerPensionPlans.getIn(['pensionPlan', 'name']);
    const formatPlanName = planName.replace(BROKER_HIRE_PLAN_FORMAT_MAIL, '_');
    const intervenerName = trim(immIntervener.get('name'));
    const intervenerLastName = get(intervenerName.split(" "), '[0]');
    const formatLastName = trim(intervenerLastName).replace(BROKER_HIRE_PLAN_FORMAT_MAIL, '_');
    const downloadFileName = `BA_${formatPlanName}_${formatLastName}.pdf`;
    const product = brokerHirePensionPlan.get('planProductNumber');
    const contractNumber = brokerHirePensionPlan.get('planContractNumber');
    const fullContractNumber = IbanHelper.calculateContract(`${product}${contractNumber}`);

    const requestData = {
        header: {
            version: 2
        },
        query: {
            documentationId: brokerLegalDocumentation.get('uuid'),
            codigoPeriodicidad: immHirePensionPlanStep1.get('periodicity'),
            contratoPlan: {
                numerodecontrato: contractNumber,
                producto: product
            },
            cuentaAsociada: {
                numerodecontrato: immAccount.get('contractNumber'),
                producto: immAccount.get('product')
            },
            dataToken: signaturePatternToken,
            datos: {
                dato: [
                    {
                        formaIntervencion: immIntervener.get('interventionForm').trim(),
                        formaIntervencionTXT: immIntervener.get('interventionFormTXT').trim(),
                        intervencion: immIntervener.get('interventionType').trim(),
                        intervencionTXT: immIntervener.get('type').trim(),
                        nombre: intervenerName,
                        nombreTXT: immIntervener.get('nameTXT').trim(),
                        numPersona: selectedIntervener,
                        tipoPersona: immIntervener.get('personType').trim()
                    }
                ]
            },
            dgsCode: dgsCode,
            divisaImportePeriodico: pensionPlanCurrency,
            fechaOrden: moment().format(DATE_FORMAT_API),
            finalAccountNumber: accountNumber,
            importeInversion: {
                divisa: pensionPlanCurrency,
                importe: immHirePensionPlanStep1.get('initialContribution').toFixed(2)
            },
            incrementoAnual: immHirePensionPlanStep1.get('annualIncrement') ? immHirePensionPlanStep1.get('annualIncrementPercentage') : 0.00,
            isContratacionesFlow: true, //@harcoded
            mailRequest: {
                contratoPrestacionUrl: contractProvisionServicesNaturalPersonsUrl,
                datosFundamentalesUrl: fundamentalPlanDataUrl,
                especificacionesPlanUrl: specificationsDocumentUrl,
                fileName: downloadFileName
            },
            nombrePlan: planName,
            numPersonaTitular: selectedIntervener,
            providerCompanyName: brokerPensionPlans.getIn(['pensionPlan', 'provider']),
            saveRequest: {
                category: BROKER_HIRE_PENSION_PLAN_CATEGORY,
                subCategory: BROKER_HIRE_PENSION_PLAN_SUB_CATEGORY,
                idContract: fullContractNumber
            },
            subtipo: brokerPensionPlans.getIn(['pensionPlan', 'subtype']),
            // @hardcoded
            tipoPersonaTitular: 'F' //immHirePensionPlanStep1.getIn(['interveners', selectedIntervener, 'personType'])
        }
    };

    if (periodicityDate) {
        requestData.query.fechaPeriodica = periodicityDate
        requestData.query.importePeriodico = {
            divisa: pensionPlanCurrency,
            importe: periodictyAmount
        };
    }

    dispatch(hirePensionPlanInProgress());
    return APIPost(dispatch, apiURLBuilder.getURL('brokerHirePensionPlanConfirm'), requestData)
        .then(response => {
            hirePensionPlanDownloadPDF(response, downloadFileName);
            dispatch(hirePensionPlanGetLink(response));
            dispatch(hirePensionPlanSuccess(response));
            BrokerMyInvestmentsActions.fetchMyInvestments();
        })
        .catch(response => {
            if (response.error) {
                dispatch(hirePensionPlanFailure(response));
            }
            const errorKey = get(response, ['body', 'error'], '');
            dispatch(errorActions.show('brokerAPIErrors-' + errorKey, true, history));
        });
};

const validateWithAPI = (history) => (dispatch, getState) => {
    const immHirePensionPlanStep1 = getState().brokerHirePensionPlan.getIn(['steps', FIRST_STEP]);
    const isFetching = getState().brokerHirePensionPlan.get('isFetching');

    if (isFetching) {
        return;
    }

    const immAccount = getState().accounts.getIn(['byId', immHirePensionPlanStep1.get('accountId')]);

    if (!immAccount) {
        return;
    }

    const immPensionPlan = getState().brokerPensionPlans;
    const pensionPlanCurrency = immPensionPlan.getIn(['pensionPlan', 'customMinimumPurchaseAmount', 'currency']);

    let periodicityDate = null;
    let periodictyAmount = 0;

    if (immHirePensionPlanStep1.get('periodicContribution')) {
        periodicityDate = immHirePensionPlanStep1.get('periodicityDate').format(DATE_FORMAT_API);
        periodictyAmount = immHirePensionPlanStep1.get('periodicityAmount');
    }

    const selectedIntervener = immHirePensionPlanStep1.get('selectedIntervener');
    const codigoIncremento = immHirePensionPlanStep1.get('annualIncrement');
    let incrementoAnual = 0;
    if (codigoIncremento && codigoIncremento !== BROKER_CONTRIBUTION_PLAN_PERIODIC_ANUAL_REV_OPTION_NOREV_VALUE) {
        incrementoAnual = immHirePensionPlanStep1.get('annualIncrementPercentage');
    }

    const requestData = {
        query: {
            codigoIncremento: codigoIncremento,
            codigoPeriodicidad: immHirePensionPlanStep1.get('periodicity'),
            cuentaSeleccionada: {
                numerodecontrato: immAccount.get('contractNumber'),
                producto: immAccount.get('product')
            },
            fechaOrden: moment().format(DATE_FORMAT_API),
            importeCuentaSeleccionada: {
                divisa: immAccount.getIn(['balance', 'currency']),
                importe: immAccount.getIn(['balance', 'amount'])
            },
            importePeriodico: {
                divisa: pensionPlanCurrency,
                importe: periodictyAmount.toFixed(2)
            },
            importeSuscripcion: {
                divisa: pensionPlanCurrency,
                importe: immHirePensionPlanStep1.get('initialContribution').toFixed(2)
            },
            incrementoAnual: incrementoAnual,
            numEmpleado: BROKER_EMPLOYEE_ID,
            subtipo: immPensionPlan.getIn(['pensionPlan', 'subtype']),
            tipo: immPensionPlan.getIn(['pensionPlan', 'type']),
            titularCodPers: selectedIntervener,
            titularTipoPers: 'F' // @hardcoded //immHirePensionPlanStep1.getIn(['interveners', selectedIntervener, 'personType'])
        }
    }

    if (periodicityDate) {
        requestData.query.fechaPeriodica = periodicityDate
    }

    dispatch(validationRequest());
    APIPost(dispatch, apiURLBuilder.getURL('brokerHirePensionPlanValidate'), requestData)
        .then(response => {
            dispatch(validationSuccess(response));
        })
        .catch(response => {
            if (response.error) {
                dispatch(apiValidationFailure(response, history));
                const errorKey = get(response, ["body", "error"], "");
                dispatch(errorActions.show("brokerAPIErrors-" + errorKey, true, history));
            } else {
                throw response;
            }
        });
};

const hirePensionPlan = (history) => (dispatch, getState) => {
    const notFetching = !getState().brokerHirePensionPlan.get('isFetching');
    const callback = (dispatch, getState, dataToken) => {
        dispatch(updateConsents(dataToken))
            .then(() => setPensionPlan(dispatch, getState, dataToken, history))
            .catch(() => setPensionPlan(dispatch, getState, dataToken, history));
    };

    if (notFetching) {
        new Promise(() => {
            signaturePatternActions.validateAndExecute(dispatch, getState, callback);
        });
    }
};

const validateStep = (step) => (dispatch, getState) => {
    let accountBalance;
    let hireMinimumAmount;
    let hireMinimumCurrency;

    if (step === WIZARD_FIRST_STEP) {
        const immBrokerPensionPlan = getState().brokerPensionPlans;
        const immBrokerHirePensionPlan = getState().brokerHirePensionPlan;
        const immAccounts = getState().accounts;

        hireMinimumAmount = immBrokerPensionPlan.getIn(['pensionPlan', 'hireMinimumAmount']);
        hireMinimumCurrency = immBrokerPensionPlan.getIn(['pensionPlan', 'hireMinimumAmountCurrency']);

        const accountId = immBrokerHirePensionPlan.getIn(['steps', FIRST_STEP, 'accountId']);
        accountBalance = immAccounts.getIn(['byId', accountId, 'balances', 'availableBalance']);
    }

    dispatch({
        type: actionTypes.BROKER_HIRE_PENSION_PLAN_VALIDATE_STEP,
        payload: {
            step: step,
            accountBalance,
            hireMinimumAmount,
            hireMinimumCurrency
        }
    });

    if (step === WIZARD_FIRST_STEP && getState().brokerHirePensionPlan.getIn(['steps', FIRST_STEP, 'valid'])) {
        dispatch(validateWithAPI());
    }
};

const toggleDisclaimer = () => (dispatch) => dispatch({
    type: actionTypes.BROKER_HIRE_PENSION_PLAN_TOGGLE_DISCLAIMER,
    payload: {}
});

const setDocumentsRead = () => (dispatch) => dispatch({
    type: actionTypes.BROKER_HIRE_PENSION_PLAN_DOCUMENTS_READ
});

const isPlanInWallet = (planId) => (dispatch, getState) => {
    const currentPlans = getState().brokerMyInvestments
        .getIn(['products', 'plans', 'stocks'])
        .map(immPlan => {
            return immPlan.get('customInstitutionSecurityId');
        });
    dispatch({
        type: actionTypes.BROKER_HIRE_PENSION_PLAN_IN_WALLET,
        payload: {
            isInWallet: currentPlans.includes(planId)
        }
    });
}

module.exports = {
    isPlanInWallet,
    hirePensionPlan,
    requestAccounts,
    requestInterveners,
    reset,
    setAccountNumber,
    setAnnualIncrement,
    setAnnualIncrementPercentage,
    setDate,
    setInitialContribution,
    setIntervener,
    setPeriodicity,
    setPeriodicityAmount,
    setVisibleStep,
    setWillCancel,
    setWillLeave,
    validateStep,
    toggleDisclaimer,
    setContributionAnswer,
    setDocumentsRead
};
